import { CurrentUser, User } from "../../graphql/types";
import { transformAuth0Permissions } from "./permission";

const PERMISSIONS_CLAIM = "https://vpd.law/permissions";
const CREATED_AT_CLAIM = "https://vpd.law/createdAt";
const IS_AD_USER_CLAIM = "https://vpd.law/is_ad_user";

export function transformAuth0User(user: any): CurrentUser {
  if (!user) {
    return;
  }

  const displayName = user.name;
  const initials = displayName
    .match(/\b(\w)/g)
    ?.join("")
    .toUpperCase();

  return new User(
    user.sub,
    displayName,
    user.email,
    user[CREATED_AT_CLAIM],
    transformAuth0Permissions(user[PERMISSIONS_CLAIM] as string[]),
    Boolean(user[IS_AD_USER_CLAIM]),
    initials,
    user.picture
  );
}
